import React from 'react'
import PropTypes from 'prop-types'

const SearchIcon = ({
  title = 'Search',
  width = 32,
  height = 32,
}) => (
  <svg title={title} className="SearchIcon" width={width} height={height} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.51 19C15.9283 19 19.51 15.4183 19.51 11C19.51 6.58172 15.9283 3 11.51 3C7.09173 3 3.51001 6.58172 3.51001 11C3.51001 15.4183 7.09173 19 11.51 19Z" stroke="#F6F6F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21.51 21L17.16 16.65" stroke="#F6F6F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

)

SearchIcon.propTypes = {
  title: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default SearchIcon
